import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { FullLogo } from "@/components/Brand";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Shell = ({ title, subtitle, children }) => (
  <div className="mx-auto grid min-h-[calc(100vh-4rem)] max-w-6xl items-stretch lg:grid-cols-2">
    <div className="navy-hero grain relative hidden flex-col justify-between overflow-hidden p-12 text-white lg:flex">
      <div className="relative z-10 self-start rounded-2xl bg-white/95 p-4 shadow-xl"><FullLogo className="h-28" /></div>
      <div className="relative z-10">
        <h2 className="text-4xl font-extrabold leading-tight">Langkah Cerdas,<br /><span className="gold-text">Raih Prestasi.</span></h2>
        <p className="mt-4 max-w-sm text-slate-300">Simulasi CAT untuk CPNS, Kedinasan, PPPK, TNI, POLRI, BUMN, dan Psikotes.</p>
      </div>
      <p className="text-xs text-slate-500">ADIKARA ACADEMY</p>
    </div>
    <div className="flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 lg:hidden"><FullLogo className="h-20" /></div>
        <h1 className="text-3xl font-extrabold text-[#0A192F]">{title}</h1>
        <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);

export const LoginPage = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success(`Selamat datang, ${u.name}`);
      nav(params.get("next") || (u.role === "admin" ? "/admin" : "/dashboard"));
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Shell title="Masuk" subtitle="Masuk ke akun ADIKARA ACADEMY Anda.">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div><Label>Email</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email-input" /></div>
        <div><Label>Kata sandi</Label><Input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password-input" /></div>
        <button disabled={busy} className="btn-gold w-full rounded-lg py-3 disabled:opacity-60" data-testid="login-submit-btn">{busy ? "Memproses..." : "Masuk"}</button>
        <p className="text-center text-sm text-slate-500">Belum punya akun? <Link to="/daftar" className="font-bold text-amber-700" data-testid="login-to-register">Daftar</Link></p>
        <p className="text-center text-xs text-slate-400">Lupa kata sandi? Hubungi admin untuk mengatur ulang.</p>
      </form>
    </Shell>
  );
};

export const RegisterPage = () => {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 6) return toast.error("Kata sandi minimal 6 karakter");
    if (f.password !== f.confirm) return toast.error("Konfirmasi kata sandi tidak sama");
    setBusy(true);
    try {
      await register({ name: f.name, email: f.email, phone: f.phone, password: f.password });
      toast.success("Registrasi berhasil");
      nav("/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Shell title="Daftar Akun" subtitle="Buat akun peserta gratis.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div><Label>Nama lengkap</Label><Input required minLength={2} value={f.name} onChange={set("name")} data-testid="register-name-input" /></div>
        <div><Label>Email</Label><Input type="email" required value={f.email} onChange={set("email")} data-testid="register-email-input" /></div>
        <div><Label>No. HP (opsional)</Label><Input value={f.phone} onChange={set("phone")} data-testid="register-phone-input" /></div>
        <div><Label>Kata sandi</Label><Input type="password" required value={f.password} onChange={set("password")} data-testid="register-password-input" /></div>
        <div><Label>Konfirmasi kata sandi</Label><Input type="password" required value={f.confirm} onChange={set("confirm")} data-testid="register-confirm-input" /></div>
        <button disabled={busy} className="btn-gold w-full rounded-lg py-3 disabled:opacity-60" data-testid="register-submit-btn">{busy ? "Memproses..." : "Daftar"}</button>
        <p className="text-center text-sm text-slate-500">Sudah punya akun? <Link to="/login" className="font-bold text-amber-700" data-testid="register-to-login">Masuk</Link></p>
      </form>
    </Shell>
  );
};
